import { gql } from '@apollo/client';

import { COMMENT_FIELDS, TASK_LIGHT_FRAGMENT } from './fragments';

// ---- tasks ---------------------------------------------------------------

export const CREATE_SUPPORT_TASK_MUTATION = gql`
  mutation Task_Create($input: CreateTaskInput!) {
    Task_Create(input: $input) {
      ...TaskLight
    }
  }
  ${TASK_LIGHT_FRAGMENT}
`;

export const UPDATE_SUPPORT_TASK_MUTATION = gql`
  mutation Task_Update($input: UpdateTaskInput!) {
    Task_Update(input: $input) {
      ...TaskLight
    }
  }
  ${TASK_LIGHT_FRAGMENT}
`;

export const SET_FOLDER_MUTATION = gql`
  mutation Task_SetFolder($taskId: String!, $folderId: String!) {
    Task_SetFolder(taskId: $taskId, folderId: $folderId) {
      ...TaskLight
    }
  }
  ${TASK_LIGHT_FRAGMENT}
`;

export const SET_ASSIGNEE_MUTATION = gql`
  mutation Task_SetAssignee($taskId: String!, $assignee: String) {
    Task_SetAssignee(taskId: $taskId, assignee: $assignee) {
      ...TaskLight
    }
  }
  ${TASK_LIGHT_FRAGMENT}
`;

export const ADD_WATCHER_MUTATION = gql`
  mutation Task_AddWatcher($taskId: String!) {
    Task_AddWatcher(taskId: $taskId) {
      ...TaskLight
    }
  }
  ${TASK_LIGHT_FRAGMENT}
`;

export const REMOVE_WATCHER_MUTATION = gql`
  mutation Task_RemoveWatcher($taskId: String!) {
    Task_RemoveWatcher(taskId: $taskId) {
      ...TaskLight
    }
  }
  ${TASK_LIGHT_FRAGMENT}
`;

// ---- comments ------------------------------------------------------------

export const ADD_SUPPORT_TASK_COMMENT_MUTATION = gql`
  mutation TaskComment_Create($input: TaskCommentInput!) {
    TaskComment_Create(input: $input) {
      ...TaskCommentFields
    }
  }
  ${COMMENT_FIELDS}
`;

export const UPDATE_SUPPORT_TASK_COMMENT_MUTATION = gql`
  mutation TaskComment_Update($input: UpdateTaskCommentInput!) {
    TaskComment_Update(input: $input) {
      ...TaskCommentFields
    }
  }
  ${COMMENT_FIELDS}
`;

export const DELETE_SUPPORT_TASK_COMMENT_MUTATION = gql`
  mutation TaskComment_Delete($commentId: String!) {
    TaskComment_Delete(commentId: $commentId)
  }
`;

// ---- folders -------------------------------------------------------------

export const CREATE_SUPPORT_TASK_FOLDER_MUTATION = gql`
  mutation TaskFolder_Create($input: TaskFolderInput!) {
    TaskFolder_Create(input: $input) {
      id
      name
      icon
      color
      sortingIndex
      systemName
      markTaskAsCompleted
    }
  }
`;

export const UPDATE_SUPPORT_TASK_FOLDER_MUTATION = gql`
  mutation TaskFolder_Update($id: String!, $input: UpdateTaskFolderInput!) {
    TaskFolder_Update(id: $id, input: $input) {
      id
      name
      icon
      color
      sortingIndex
      systemName
      markTaskAsCompleted
    }
  }
`;

export const REORDER_SUPPORT_TASK_FOLDERS_MUTATION = gql`
  mutation TaskFolder_Reorder($ids: [String!]!) {
    TaskFolder_Reorder(ids: $ids)
  }
`;

export const DELETE_SUPPORT_TASK_FOLDER_MUTATION = gql`
  mutation TaskFolder_Delete($id: String!, $moveToFolderId: String) {
    TaskFolder_Delete(id: $id, moveToFolderId: $moveToFolderId)
  }
`;
